import { Image } from '../services/client'
import type { TQrDesign } from '../services/types'

export const QrPreviewScreen = ({
	data,
	qrDesign,
}: {
	data: string
	qrDesign: TQrDesign
}) => (
	// TODO: Replace hardcoded size with full width & height
	<div className="flex h-[544px] w-[260px] items-center justify-center bg-white">
		{qrDesign ? (
			<Image
				data={data}
				qrDesign={qrDesign}
				size={170}
				className="translate-y-[calc(71px_/_2)]"
			/>
		) : null}
	</div>
)
